
import { Component, Prop, BaseMixins, Provide, Watch } from "@/lib";
@Component({ name: "form-page" })
export default class FormPage extends BaseMixins {
  /*Card title多语言key*/
  @Prop({ type: String }) pageTitleL: string;
  /*Card title是否显示*/
  @Prop({ type: Boolean }) hideTitle: boolean;
  /*标签的宽度 默认150*/
  @Prop({ type: Number, default: 120 }) labelWidth: number;
  /*ok text key*/
  @Prop({ type: String, default: "Action.Save" }) okText: string;
  /*back text key*/
  @Prop({ type: String, default: "Action.Back" }) backText: string;
  /** 成功提示消息文本 */
  @Prop({ type: String, default: "Tip.SavedSuccessfully" }) successMsgText: string;
  /** 表单模型 */
  @Prop({ type: Object, required: true }) model: any;
  /** get dispatch type */
  @Prop({ type: String }) getAction: string;
  /** ok dispatch type 需要操作数据库时 */
  @Prop({ type: String }) okAction: string;
  /*不显示OK 按钮*/
  @Prop({ type: Boolean, default: false }) isHideOk: boolean;
  /*不显示Back 按钮*/
  @Prop({ type: Boolean, default: false }) isHideBack: boolean;
  /*ok 后 返回Index页面*/
  @Prop({ type: Boolean, default: false }) isRedirectIndex: boolean;
  @Prop({ type: Function }) preSubmit: Function;
  @Prop({ type: Function }) loadedFail: Function;
  @Prop({ type: Boolean, default: false }) formLoading: boolean;

  loading: boolean = false;

  @Provide("modelValidateError")
  modelValidateError: any = { error: {} };

  @Watch("formLoading")
  watchLoading(value) {
    this.loading = value;
  }

  async getRecord() {
    this.loading = true;
    await this.$store
      .dispatch(this.getAction, this.$route.query)
      .catch((error) => {
        if (this.loadedFail) {
          this.loadedFail(error);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  ok() {
    let self = this;
    this.formValidate(async (model: any) => {
      //若有定义提交前函数，则触发提交前函数
      if (this.preSubmit) {
        if (!this.preSubmit(self.model)) {
          return;
        }
      }
      if (this.okAction) {
        try {
          this.loading = true;
          await this.$store.dispatch({ type: this.okAction, data: this.model }).finally(() => {
            this.loading = false;
          });

          this.$Message.success(this.L(this.successMsgText));
          if (this.isRedirectIndex) {
            this.back();
          }
          this.$emit("save-succss", this.model);
        } catch (e:any) {
          if (!e.response) return;
          let tempValidateError = e.response.modelValidationErrors;
          //业务逻辑验证
          if (tempValidateError) {
            for (let key in tempValidateError) {
              tempValidateError[key] = tempValidateError[key] + "_" + this.$util.guid(); //添加guid 触发 控件基类FormComponentBase  中的watch
            }
            Object.assign(this.modelValidateError, {
              error: tempValidateError,
            });
          }
        }
      }
    });
  }

  formValidate(callback?: Function) {
    (this.$refs["formPage"] as any).validate(async (valid: boolean) => {
      if (valid) {
        if (callback) {
          callback(Object.assign({}, this.model));
        }
      }
    });
  }

  get title() {
    if (this.pageTitleL) return this.L(this.pageTitleL);
    return this.L(this.$route.meta.title);
  }

  triggerFieldValidate(prop: string) {
    (this.$refs["formPage"] as any).validateField(prop);
  }
}
